'use client';

import type { Breadcrumb } from '@eliadmin/core/src/api/products/types/product-types';
import { JsonLdScript } from '@eliadmin/core/src/components/seo/json-ld-script';
import { buildBreadcrumbListItems } from '@eliadmin/core/src/components/seo/breadcrumbs-schema-utils';
import { getFlatBreadcrumbs } from '@eliadmin/core/src/utils/url-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

type BreadcrumbsSchemaProps = {
  breadcrumb?: Breadcrumb | null;
};

export function BreadcrumbsSchema({ breadcrumb }: BreadcrumbsSchemaProps) {
  const { t } = useTranslations();
  if (!breadcrumb) return null;

  const breadcrumbs = getFlatBreadcrumbs(breadcrumb);
  const baseUrl = (process.env.NEXT_PUBLIC_APP_URL ?? '').replace(/\/$/, '');
  const homeName = t('text160').trim() || 'Domov';
  const normalizedItems = buildBreadcrumbListItems(breadcrumbs, baseUrl);
  if (!normalizedItems) return null;
  const itemListElement = normalizedItems.map((item, index) =>
    index === 0 ? { ...item, name: homeName } : item,
  );
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };

  return <JsonLdScript data={schema} />;
}
